import React from 'react'
import Loader from './loader'
import Header from './header'
import Navbar from './navbar'
import { Helmet } from 'react-helmet'



const Layout = ({pageTitle, children}) => {

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{pageTitle}</title>
                <meta name="description" content="OurShare is PragICTS' unwavering commitment to Corporate Social Responsibility (CSR), where we focus on sharing our successes, expertise, and resources in ways that truly matter. As a responsible, ethical, and conscious company, we believe in playing an active role in making a difference—not only through our business practices but by contributing to the greater good of society. We aim to create a positive and lasting impact on our community, the environment, and the world at large.
" />
                <meta name="keywords" content="Software Development Services, Mobile Application Development Services, Website Development Services, Web Application Development Services, IT and Cloud Automation Development Services, IoT Application and Integration Development Services." />
                <meta property="og:title" content="PragICTS | OurShare" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://s3.ap-southeast-1.amazonaws.com/itops.pragicts.com/1.png" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:type" content="image/png" />
                <meta name="twitter:card" content="summary_large_image" />

                <meta property="og:description" content="OurShare is PragICTS' unwavering commitment to Corporate Social Responsibility (CSR), where we focus on sharing our successes, expertise, and resources in ways that truly matter. As a responsible, ethical, and conscious company, we believe in playing an active role in making a difference—not only through our business practices but by contributing to the greater good of society. We aim to create a positive and lasting impact on our community, the environment, and the world at large.
" />
                <meta property="og:site_name" content="PragICTS" />


                <meta property="og:type" content="PragICTS" />
                <meta property="og:site_name" content="PragICTS | OurShare" />
                <meta name="og:email" content="info@pragICTS.com" />
                <meta name="og:phone_number" content="00 94 76 298 8284" />
                <link rel="canonical" href="https://pragicts.com" />
                <script type="text/javascript" src="https://widget.clutch.co/static/js/widget.js"></script> 
            </Helmet>
            <Loader />
            <div id="main">
                <Header />
                <Navbar />
                {children}
            </div>
        </>
    )
}

export default Layout
